module.exports = __webpack_public_path__ + "static/agefis-vll0Bb04XTc-unsplash-f49dbada8701aee9fc70bdea2f334af9.png";